<template>
  <div>
    <el-dialog
      :visible.sync="viewDialogVisible"
      :modal-append-to-body='true'
      :close-on-click-modal="false"
      :close-on-press-escape='false'
      :title="$lang('申购内容明细')"
      @open="openFn"
      @close="close"
      width="800px"
      class="materialPurchase-detail">
      <div class="dialog-content">
        <div class="main-table materialPurchase-table-box">
          <JmsTableScroll
            ref="table"
            :option="listOpt"
            :data="grantDetailList"
            :page="page"
            :table-loading="loading"
            :summary-method="sumMethod"
            :tablePageVisible="false"
            @size-change="sizeChange"
            @select-change="selectionChange"
            @current-change="currentChange">
            <!-- 运单号 -->
            <template slot="shipmentNumber" slot-scope="data">
              <el-tooltip placement="top">
                <div slot="content" @click="handleCopy(data.row.shipmentNumber)" style="cursor:pointer">{{ $lang('复制运单号') }}</div>
                <span @click="getExpressTracking(data.row.shipmentNumber)" class="getExpressTracking">{{ data.row.shipmentNumber }}</span>
              </el-tooltip>
            </template>
            <!-- 运单号 -->
            <template slot="purchaseCount" slot-scope="{ row }">
              <div v-if="!row.shipmentNumber" class="purchaseCount-box">
                <el-input-number
                    v-model.trim="row.purchaseCount"
                    :min="row.minPurchaseQuantityCount"
                    :max="999999"
                    :step="row.minPurchaseQuantityCount"
                    :step-strictly="true"
                    @input="val => val && val.toString().replace(/[^\d]/g, '')"
                  >
                </el-input-number>
                <el-button class="save-btn" type="text" icon="el-icon-check" :loading="updateLoading" @click="purchaseCountUpdate(row)"></el-button>
              </div>
              <span v-else>{{ row.purchaseCount || '--' }}</span>
            </template>
          </JmsTableScroll>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import JmsTableScroll from '@/components/jms-widget/jms-table-scroll'
import { copyText } from '@utils/common'
import { changeNum } from '@api/module/customer'
import { RESPONSE_SUCCESS } from '@constants'

export default {
  name: 'Add',
  components: {
    JmsTableScroll,
  },
  props: {
    viewDialogVisible: {
      type: Boolean,
      default: false
    },
    grantDetailList: {
      type: Array,
      default: () => []
    },
    rowCode: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      updateLoading: false,
    }
  },
  computed: {
    listOpt() {
      const that = this
      return {
        fixHeight: 90,
        selection: false,
        menu: false,
        column: [
          {
            label: '物料信息',
            prop: 'materialName',
          },
          {
            label: '物料编码',
            prop: 'materialCode',
          },
          {
            label: '物料单价',
            prop: 'materialUnitPrice',
          },
          {
            label: '物料数量',
            prop: 'purchaseCount',
            width: 220,
            slot: true
          },
          {
            label: '物料说明',
            prop: 'decr',
          },
          {
            label: '状态',
            prop: 'status',
            formatter: ({ status }) => {
              const map = {
                1: '未发货',
                2: '已发货',
                3: '已签收',
                4: 'Returning',
                5: 'Returned',
              }
              return that.$lang(map[status])
            }
          },
          {
            label: '运单号',
            prop: 'shipmentNumber',
            slot: true,
          },
          {
            label: '最后修改时间',
            prop: 'lastUpdateTime',
            width: 150
          },
        ]
      }
    }
  },
  methods: {
    // 更新物料申购数量
    async purchaseCountUpdate(row) {
      try {
        const params = {
          code: this.rowCode,
          purchaseCount: row.purchaseCount,
          detailId: row.id,
        }
        this.updateLoading = true
        const { code, msg } = await changeNum(params)
        this.updateLoading = false
        if (code === RESPONSE_SUCCESS) {
          this.updateLoading = false
          this.$message.success(this.$lang('修改成功'))
        } else {
          this.$message.error(this.$lang(msg))
        }
      } catch (err) {
        console.log(err)
        this.updateLoading = false
      }
    },
    // 复制
    handleCopy(text) {
      copyText(text)
    },
    /**
     * 去快件查询
     */
    getExpressTracking(waybillId) {
      this.$router.push({ path: '/expressTracking', query: { waybillId }}, () => {
        this.close()
      })
    },
    openFn() {},
    close() {
      this.$emit('update:viewDialogVisible', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-top{
  display: flex;
  justify-content:space-between;
  align-items: center;
  .dialog-detail{
    display: flex;
    justify-content:flex-start;
    align-items: center;
    .detail{
      font-size: 24px;
      font-family:PingFangSC-Medium,PingFangSC;
      font-weight:500;
      color:rgba(51,51,51,1);
      line-height:16px;
      font-weight: 600;
    }
  }
  .dialog-close{
    width: 16px;
    height: 16px;
    display: inline-block;
    cursor: pointer;
  }
}

.getExpressTracking {
  color: blue;
}

.purchaseCount-box {
  position: relative;
  display: flex;
  align-items: center;
}
</style>

<style lang="scss">
.materialPurchase-table-box {
  .purchaseCount-box {
    .save-btn {
      padding: 0;
      .el-icon-check {
        font-size: 22px !important;
      }
    }
  }
}
</style>

